import React from "react";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import Select from "Components/select/Select";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import isEmail from "validator/lib/isEmail";
import { province, euCountries } from "../../../config";
import PropTypes from "prop-types";
import InputVerify from "Components/inputVerify/InputVerify";
import InputPhone from "Components/inputPhone/InputPhone";
import t from "Utils/translation";
import _ from "lodash";
import HelpTooltip from "Components/helpTooltip/HelpTooltip";

import SupportContactBox from "Components/supportContactBox/SupportContactBox";
import cx from "classnames";
// import s from "./orderForm.scss";

const ContextTypes = {
  router: PropTypes.object,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

export default class PersonalDataStep extends React.Component {
  constructor(props) {
    super(props);

    const { formData } = props;

    this.state = {
      vatValid: false,
      isVerifingVAT: false,
      isVerifingFiscalcode: false,
      fiscalcodeValid: false,
      showVAT: euCountries.includes(formData.country) && formData.customer_type !== "private",
      isVATRequired: formData.customer_type !== "private" && formData.country === "IT",
    };
  }

  UNSAFE_componentWillMount() {
    this.props.setFormFieldValue({
      firstname: this.props.customer.firstname,
      lastname: this.props.customer.lastname,
    });
  }

  goToNextStep = () => {
    let errors = this.validate(this.props.formData);
    console.log("errors", errors);

    if (Object.keys(errors).length > 0) {
      this.props.setFormErrors(errors);
    } else {
      this.props.goToStep(4);
    }
  };

  goBack = () => {
    this.resetViewFields();
    this.props.goToStep(2);
  };

  // verifyVAT(vat) {
  //   this.setState({ isVerifingVAT: true });
  //   setTimeout(() => {
  //     // 10 chars long because of all europeans VAT the shortest is composed by 8 char (Czech Rep.),
  //     // to these we must add the 2 letters of the country (IT, EN, etc...)
  //     if (!vat || vat.length < 10) {
  //       this.props.setFormErrors({ vat: t("input.verify.error.vat") });
  //       this.setState({ isVerifingVAT: false });
  //     } else {
  //       this.setState({ vatValid: true, isVerifingVAT: false });
  //       this.props.setFormErrors({ vat: false });
  //     }
  //   }, 1200);
  // }

  verifyFiscalcode = (code) => {
    this.setState({ isVerifingFiscalcode: true });
    this.props
      .verifyFiscalcode(_.trim(code))
      .then(() => {
        this.setState({ fiscalcodeValid: true, isVerifingFiscalcode: false });
        this.props.setFormErrors({ fiscalcode: false });
      })
      .catch(() => {
        this.props.setFormErrors({
          fiscalcode: t("errorMsg.click.toVerify"),
        });
        this.setState({ isVerifingFiscalcode: false });
      });
  };

  resetViewFields = () => {
    this.props.setFormFieldValue({
      address1: "",
      city: "",
      companyname: "",
      state: "",
      vat: "",
      postcode: "",
      fiscalcode: "",
      phonenumber: "",
    });
  };

  validate = (data) => {
    let errors = {};
    let requireds = ["firstname", "lastname", "address1", "city", "state", "postcode", "phonenumber"];

    if (this.state.isVATRequired && this.state.showVAT) {
      requireds.push("vat");

      if (data.vat?.length <= 2) {
        errors.vat = t("status.migrationInvalid");
      }
    }

    if (data.customer_type === "company" || data.customer_type === "reseller") {
      requireds.push("companyname");
    } else {
      requireds.push("fiscalcode");
      if (!this.state.fiscalcodeValid) {
        errors.fiscalcode = t("errorMsg.click.toVerify");
      }
    }

    if (data.recipientCode && data.recipientCode.length != 7 && !isEmail(data.recipientCode)) {
      errors.recipientCode = t("errorMsg.notValid.recipientCode");
    }

    requireds.forEach((field) => {
      if (field === "phonenumber" && data[field].length < 4) {
        errors[field] = t("input.error.empity");
      }

      if (!data[field]) errors[field] = t("input.error.empity");
    });

    console.log("errors", errors, data);

    return errors;
  };

  // updateVATValue(val) {
  //   const {
  //     formData: { country },
  //     setFormFieldValue
  //   } = this.props;
  //   let newVal = val.vat.length < 2 ? "" : val.vat.replace(country, "");

  //   setFormFieldValue({
  //     vat: newVal
  //   });
  // }

  render() {
    const {
      customer: { firstname, lastname },
      formErrors,
      formData,
      setFormFieldValue,
    } = this.props;

    const { showVAT, isVATRequired } = this.state;

    const { isMediaMobile, isMediaSM, isMediaMD } = this.context;

    let showCompanyFields = formData.customer_type === "company" || formData.customer_type === "reseller";

    return (
      <div className="orderPage">
        {this.props.stepper}

        {!isMediaMobile() && !isMediaSM() && !isMediaMD() && <SupportContactBox className="supportBox" />}

        <div className={cx("sectionTitle", "titleFP")}>{t("order.add.title.step3")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">{t("order.add.desc.step3")}</div>
          </div>

          <div className="wrapFormsFP">
            <div className="formsFP">
              {showCompanyFields && (
                <Input
                  className="inputFull2"
                  label={t("input.label.company")}
                  placeholder={t("input.placeholder.company")}
                  name="companyname"
                  required
                  value={formData.companyname}
                  errors={formErrors.companyname}
                  onChange={setFormFieldValue}
                />
              )}

              <Input
                className="inputFull2"
                label={t("input.label.firstName")}
                placeholder={t("input.placeholder.firstName")}
                name="firstname"
                required
                initialValue={firstname}
                value={formData.firstname}
                errors={formErrors.firstname}
                onChange={setFormFieldValue}
                helpTooltip={
                  showCompanyFields && (
                    <HelpTooltip
                      //eslint-disable-next-line react/no-children-prop
                      children={[
                        {
                          description: t("helpT.order.company.referent"),
                        },
                      ]}
                    />
                  )
                }
              />

              <Input
                className={cx("inputFull2", "inputAddMargin")}
                label={t("input.label.lastName")}
                placeholder={t("input.placeholder.lastName")}
                name="lastname"
                required
                initialValue={lastname}
                value={formData.lastname}
                errors={formErrors.lastname}
                onChange={setFormFieldValue}
              />

              {showCompanyFields && showVAT && (
                <Input
                  className="inputFull2"
                  label={t("input.label.vat")}
                  placeholder={t("input.placeholder.vat")}
                  name="vat"
                  value={formData.vat}
                  errors={formErrors.vat}
                  onChange={setFormFieldValue}
                  required={isVATRequired}
                />
              )}

              {showCompanyFields && formData.country === "IT" && (
                <Input
                  className={cx("inputFull2", "inputAddMargin")}
                  name="fiscalcode"
                  label={t("input.label.fiscalcode2")}
                  placeholder={t("input.placeholder.fiscalcode")}
                  value={formData.fiscalcode}
                  errors={formErrors.fiscalcode}
                  onChange={setFormFieldValue}
                />
              )}

              {showCompanyFields && formData.country === "IT" && (
                <Input
                  className={cx("inputFull2", "inputAddMargin")}
                  name="recipientCode"
                  label={t("input.label.recipientCode")}
                  placeholder={t("input.placeholder.recipientCode")}
                  value={formData.recipientCode}
                  errors={formErrors.recipientCode}
                  onChange={setFormFieldValue}
                />
              )}

              {!showCompanyFields && !showVAT && formData.country === "IT" && (
                <InputVerify
                  className={cx("inputFull2", "inputAddMargin")}
                  label={t("input.label.fiscalcode")}
                  placeholder={t("input.placeholder.fiscalcode")}
                  name="fiscalcode"
                  required
                  value={formData.fiscalcode}
                  errors={formErrors.fiscalcode}
                  onChange={setFormFieldValue}
                  loading={this.state.isVerifingFiscalcode}
                  isVerified={this.state.fiscalcodeValid}
                  onClick={this.verifyFiscalcode}
                />
              )}

              <Input
                className="inputFull2"
                name="address1"
                label={t("input.label.address")}
                placeholder={t("input.placeholder.address")}
                value={formData.address1}
                errors={formErrors.address1}
                onChange={setFormFieldValue}
                required
              />

              <Input
                name="city"
                label={t("input.label.city")}
                placeholder={t("input.placeholder.city")}
                required
                value={formData.city}
                errors={formErrors.city}
                onChange={setFormFieldValue}
              />

              {formData.country === "IT" && (
                <Select
                  label={t("input.label.state")}
                  placeholder={t("input.placeholder.city")}
                  components={{ DropdownIndicator }}
                  name="state"
                  options={province}
                  clearable={false}
                  value={formData.state}
                  errors={formErrors.state}
                  onChange={setFormFieldValue}
                  required
                />
              )}

              {formData.country !== "IT" && (
                <Input
                  name="state"
                  label={t("input.label.country")}
                  placeholder={t("input.placeholder.country")}
                  required
                  value={formData.state}
                  errors={formErrors.state}
                  onChange={setFormFieldValue}
                />
              )}

              <Input
                name="postcode"
                label={t("input.label.postcode")}
                placeholder={t("input.placeholder.postcode")}
                required
                value={formData.postcode}
                errors={formErrors.postcode}
                onChange={setFormFieldValue}
              />

              <InputPhone
                label={t("input.label.telephone")}
                placeholder={t("input.placeholder.telephone")}
                name="phonenumber"
                required
                onChange={setFormFieldValue}
                errors={formErrors.phonenumber}
                value={formData.phonenumber}
              />
            </div>

            <div className="footerFP">
              <Button color="text" type="button" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" onClick={this.goToNextStep}>
                button.continue
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PersonalDataStep.contextTypes = ContextTypes;
